module.exports = __webpack_public_path__ + "static/media/enclosure_concrete_tapcons.7d89bf9f.jpg";